import objectAssign from "object-assign";
import actionTypes from "actionTypes";

const initialState = {
  fileUploadTimeStamp: null
}

export default function coupon(state, action) {
	if (typeof state === "undefined") {
		return initialState;
	}

	let newState = null;

	switch (action.type) {
		case actionTypes.SET_DISCOUNT_PAYMENT_GATEWAY_MODE_UPLOAD_TIMESTAMP:
			newState = objectAssign({}, state);
			newState.fileUploadTimeStamp = action.payload;
			return newState;
	}
	return state;
}